import { combineReducers } from "redux";

import { addOnDetails } from "./reducer.addOn"
const addOnReducers = combineReducers({
  addOnDetails
})
export default addOnReducers;
